import { Inject, Injectable } from '@angular/core';
import { SimplifiedUser } from '@galaxy/crm/static';
import { IAMService, User } from '@vendasta/iam';
import { map, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const TEAM_MEMBER_TYPES = ['partner', 'sales_person', 'digital_agent'];

@Injectable({ providedIn: 'root' })
export class CRMUserService {
  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private readonly iam: IAMService,
  ) {}

  private buildDisplayName(user: User): string {
    return `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || 'system';
  }

  searchUsers(searchTerm?: string): Observable<SimplifiedUser[]> {
    return this.partnerId$.pipe(
      switchMap((pid) => {
        if (!pid) {
          return of([]);
        }
        const search = searchTerm?.trim().replace(/\s+/g, ' ').split(' ');
        return this.iam.listUsers(pid, '', '', 10, TEAM_MEMBER_TYPES, search?.length ? search : [], []).pipe(
          map((resp) => resp?.users || []),
          map((users) =>
            users.map(
              (user) =>
                ({
                  userId: user.userId,
                  firstName: user.firstName,
                  lastName: user.lastName,
                  displayName: this.buildDisplayName(user),
                }) as SimplifiedUser,
            ),
          ),
        );
      }),
    );
  }

  getMultiUsers(userIds: string[]): Observable<SimplifiedUser[]> {
    return this.iam.getMultiUsers(userIds.map((userId) => ({ userId }))).pipe(
      map((users) =>
        users.map(
          (user) =>
            ({
              userId: user.userId,
              firstName: user.firstName,
              lastName: user.lastName,
              displayName: this.buildDisplayName(user),
            }) as SimplifiedUser,
        ),
      ),
    );
  }
}
